"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ReportApi extends runtime.BaseAPI {
    /**
     *  (Auth roles: Admin)
     */
    apiReportSendReportPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Report/send-report`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SendEmailDtoToJSON(requestParameters.sendEmailDto),
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     *  (Auth roles: Admin)
     */
    apiReportSendReportPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiReportSendReportPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.ReportApi = ReportApi;
